import  * as InstrumentKPIConstants from './InstrumentKPIConstants';
import InstrumentKPIUtil from './InstrumentKPIUtils';


const addDeviceToInstrumentKPIReducerState = (instanceId) => {
	return {
		type: InstrumentKPIConstants.INSTRUMENT_KPI_DEVICE_STATE_ADD,
		payload: instanceId
	}
};

const removeDeviceFromInstrumentKPIReducerState = (instanceId) => {
	return {
		type: InstrumentKPIConstants.INSTRUMENT_KPI_DEVICE_STATE_REMOVE,
		payload: instanceId
	}
};

const getWorkspaceID = async (instanceId, url,token,dispatch)=> {
	await  InstrumentKPIUtil.getData(instanceId, url,token,dispatch,GroupDataSuccess,GroupDataSuccessFailure);
}


const GroupDataSuccess=(instanceId, data)=>{
	var length = (data.value).length;
	var arr ='';

  	for(var i =0; i<length ;i++) {
			if((data.value)[i].name == process.env.PowerBI_Workspace)
				arr=(data.value)[i].id;
	}

	return { type: InstrumentKPIConstants.INSTRUMENT_KPI_GROUP_ID_API_SUCCESS, payload: { instanceId, newState: arr } };
}

const GroupDataSuccessFailure=(instanceId)=>{
    return { type: InstrumentKPIConstants.INSTRUMENT_KPI_GROUP_ID_API_FAILURE, payload: instanceId };
}



// Get Report ID
const  getPowerBIData  = async (instanceId, url,token,dispatch,reportName)=> {
	await  InstrumentKPIUtil.getData(instanceId, url,token,dispatch,PowerBIDataSuccess,PowerBIDataFailure,reportName);
}

const PowerBIDataSuccess=(instanceId, data,reportName)=>{
	var length = (data.value).length;
	var arr =[];
   
  for(var i =0; i<length ;i++)
	{
		 if((data.value)[i].name == reportName)
			 {
			  arr.push((data.value)[i].id);
			  arr.push((data.value)[i].embedUrl)

			 }
	}

	return { type: InstrumentKPIConstants.INSTRUMENT_KPI_REPORT_ID_API_SUCCESS, payload: { instanceId, newState : arr } };
}

const PowerBIDataFailure=(instanceId)=>{
    return { type: InstrumentKPIConstants.INSTRUMENT_KPI_REPORT_ID_API_FAILURE, payload: instanceId };
}

export {
	addDeviceToInstrumentKPIReducerState,
	removeDeviceFromInstrumentKPIReducerState,
	getPowerBIData,
	getWorkspaceID
}